var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 7L17.6572 8.343M17.6572 8.343C16.1569 6.84267 14.122 5.99979 12.0002 5.99979C9.87842 5.99979 7.84354 6.84267 6.34321 8.343C4.84288 9.84333 4 11.8782 4 14C4 16.1218 4.84288 18.1567 6.34321 19.657C7.84354 21.1573 9.87842 22.0002 12.0002 22.0002C14.122 22.0002 16.1569 21.1573 17.6572 19.657C19.1575 18.1567 20.0004 16.1218 20.0004 14C20.0004 11.8782 19.1575 9.84333 17.6572 8.343ZM12.0002 10V14M9.00021 3H15.0002",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.0024585556ee9ab0e0c00c76261b9556.svg";
export { ForwardRef as ReactComponent };